var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0.5C1.125 0.5 0 1.625 0 3C0 4.375 1.125 5.5 2.5 5.5C3.875 5.5 5 4.375 5 3C5 1.625 3.875 0.5 2.5 0.5ZM17.5 0.5C16.125 0.5 15 1.625 15 3C15 4.375 16.125 5.5 17.5 5.5C18.875 5.5 20 4.375 20 3C20 1.625 18.875 0.5 17.5 0.5ZM7.5 3C7.5 1.625 8.625 0.5 10 0.5C11.375 0.5 12.5 1.625 12.5 3C12.5 4.375 11.375 5.5 10 5.5C8.625 5.5 7.5 4.375 7.5 3Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDefault);
export default __webpack_public_path__ + "static/media/menu-icon-default.cb0eb175.svg";
export { ForwardRef as ReactComponent };